<script>
import {Icon} from '@iconify/vue/dist/iconify';

/* COMPOSANTS */
import AkDropdown from '@components/input/AkDropdown.vue';

/* MIXINS */
import permissionsMixin from '@mixins/permissionsMixin';
import utilsMixin from '@mixins/utilsMixin';
import sidebarMixin from '@mixins/sidebarMixin';

/* SERVICES */
import companyService from '@services/companyService';

export default {
  components: {
    AkDropdown,
    Icon,
  },
  mixins: [permissionsMixin, utilsMixin, sidebarMixin],
  props: {
    modelValue: {required: true},
    callback: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      companies: [],
    };
  },
  mounted() {
    this.getCompanyList();
  },
  methods: {
    search() {
      this.callback[0]();
      this.hideSidebar();
    },
    reset() {
      this.callback[1]();
    },
    getCompanyList() {
      companyService.companies().then((data) => {
        this.companies = data;
      });
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <h2>{{ this.$t('facturation_hote.filter') }}</h2>
  <form class="d-flex flex-column" style="row-gap: 16px" @submit.prevent="search">
    <AkDropdown
      v-model="currentValue.companyId"
      :inline="true"
      className="flex-1 form-control"
      :options="companies"
      optionLabel="name"
      optionValue="id"
      :placeholder="$t('company.list')"
      :label="$t('company.list')" />

    <div class="d-flex flex-row">
      <button class="btn btn-primary btn-search flex-1" type="submit">
        {{ this.$t('search.search') }}
      </button>
      <Icon
        v-on:click="this.reset()"
        class="pointer"
        icon="basil:cross-outline"
        :style="{fontSize: '50px', width: '50px !important'}" />
    </div>
  </form>
</template>
